module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The First Judgement")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/9780310096153_template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "From The Fall of Lucifer"
    }
  }, [_c('p', {
    staticClass: "head1",
    attrs: {
      "id": "tf"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#R_tf"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('i', [_vm._v("From ‘The Fall of Lucifer’")])])])]), _vm._v(" "), _c('p', {
    staticClass: "head2",
    attrs: {
      "id": "tf1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#R_tf1"
    }
  }, [_c('i', [_vm._v("The Chronicles of Brothers, Time Before Time – Book 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he tempest built with the force of a cyclone, and a torrid inferno rose out of the blackness, illuminating the entire panorama.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lucifer lifted his forearm from his face, his mouth opening and closing mindlessly in terror as an all-consuming apocalyptic sheet of flame descended onto his angels, the scorching, incinerating flames engulfing them. ‘The consuming fire!’ he shrieked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All across the chamber, spine-chilling screams resounded as the renegade angelic host were consumed by the blistering fireball.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ll take man with me! I won’t burn alone!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His deranged screaming resounded through the darkness as the searing tongues of fire started to engulf Lucifer. He looked down incredulously at his hands. As he watched, they blistered. His broad, manicured nails twisted into talons and yellowed with age. The chiselled alabaster features became pockmarked. The jet-black eyebrows grew together. The beautiful aquiline nose became misshapen. The passionate crimson mouth grew thin and cruel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Frantic, Lucifer put his hands to his cheeks, feeling his "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("mangled, misshapen features. The magnificent thick ebony tresses fell from his scalp in smouldering clumps. His gold and ruby ring burned deep into his flesh.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Hear me, Christos!’ he screamed. ‘I, Lucifer, light-bearer, chief prince, holy angelic regent of the Royal House of Yehovah, do now become your sworn enemy, and treachery and iniquity will I bear unto you throughout eternity of eternities!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A gale-force wind blew through the chamber. The angels with Lucifer – themselves hideously transformed – clung desperately to balustrades, marble columns, and overturned marble tables as they were sucked away from the throne room. They screamed frenziedly as the lightning raged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, propelled by some unseen gargantuan magnetic force, they and everything in their wake were sucked towards the swirling black vortex beyond the chamber entrance.")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "quote"
  }, [_c('i', [_vm._v("The shadows had fallen")]), _vm._v(" . . .")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d55bc3c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780310096153_From_The_Fall_of_Lucifer.vue
// module id = 72
// module chunks = 0